(function ($) {
    $(() => {
        
       
        $('.access-row .badge').on('click', function() {

            let class_name = $(this).parent().data('class');
    
            $(this).parent().find('.badge').removeClass('active');
            $(this).addClass('active');
    
            Cookies.remove(class_name);
            $('html').removeClass(class_name);
    
            if($(this).hasClass('on')) {
                $('html').addClass(class_name);

                Cookies.set(class_name, true);
    
                setTimeout(() => {
    
                    $('.match-h-2').matchHeight({
                        byRow: false,
                        property: 'height',
                        target: null,
                        remove: false
                    });
    
                    $('.match-h').matchHeight({
                        byRow: true,
                        property: 'height',
                        target: null,
                        remove: false
                    });
            
                    $('.match-h-h').matchHeight({
                        byRow: true,
                        property: 'height',
                        target: null,
                        remove: false
                    });
                }, 500);
            }
        });
    
        $('a').on('click', function(event) {
            var linkTargetBlank = $('html').hasClass('link-target-access');
            if (linkTargetBlank) {
                $(this).attr('target', '_blank');
            } else {
                var originalTarget = $(this).attr('target');
                if (originalTarget !== undefined && originalTarget !== '') {
                    $(this).attr('target', originalTarget);
                }
            }
        });

        const cookies = [
            'font-family-access',
            'font-size-access',
            'line-height-access',
            'letter-spacing-access',
            'color-schema-access',
            'separation-access',
            'word-spacing-access',
            'link-apperance-access',
            'link-target-access'
        ];

        cookies.forEach(element => {
            if(Cookies.get(element)) {
                $(`[data-class="${element}"]`).find('.off').removeClass('active');
                $(`[data-class="${element}"]`).find('.on').addClass('active');
                $('html').addClass(element);
            }
        });

    });
})(jQuery);

